export default __webpack_public_path__ + "static/media/quiz-pic-9.a0023fac.jpeg";